exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.table-bordered>tbody>tr>td{\r\n    vertical-align: middle;\r\n    color: black;\r\n  }\r\n\r\n\r\n  @media print {\r\n    input,label,.panel-title,.panel,.dataTables_length,select{\r\n      display: none !important;\r\n    }\r\n    #print_info{\r\n      display: none !important;\r\n    }\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/tejashree/src/app/orderlist/orderlist.component.css
// module id = ../../../../../src/app/orderlist/orderlist.component.css
// module chunks = main